<template>
  <LmDialog v-model="modalShow" :styles="{ minWidth: '400px' }" title="Add attachment">
    <template #toolbar-actions>
      <q-btn :disable="!file" size="sm" label="Save" color="tertiary" @click="submit" />
    </template>

    <template #content>
      <q-card-section style="height: 80px">
        <FileUploader v-model="file" stack-label="File to upload" />
      </q-card-section>
    </template>
  </LmDialog>
</template>

<script>
import { get } from 'lodash'
// Components
import LmDialog from '@/reusable/base-components/LmDialog/LmDialog'
import FileUploader from '@/reusable/FileUploader/FileUploader'

export default {
  name: 'FormCreateAttachment',
  components: { LmDialog, FileUploader },
  inject: ['service'],
  props: {
    showing: {
      type: Boolean,
      default: false
    },
    namespace: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      file: null
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.showing
      },
      set(value) {
        !value && this.closeModal()
      }
    }
  },
  methods: {
    submit() {
      let formData = new FormData()
      formData.append('file', this.file)
      let params = {
        value: formData
      }
      this.createAttachment(params)
    },
    createAttachment(params) {
      this.service.create(params).then(({ data }) => {
        if (!get(data, 'messages.errors')) {
          this.$emit('refresh', data.result)
          this.resetData()
          this.closeModal()
        }
      })
    },
    resetData() {
      this.file = null
    },
    closeModal() {
      this.$emit('close')
      this.resetData()
    }
  }
}
</script>
